import { render, staticRenderFns } from "./xinmingm.vue?vue&type=template&id=474f2c44"
import script from "./xinmingm.vue?vue&type=script&lang=js"
export * from "./xinmingm.vue?vue&type=script&lang=js"
import style0 from "./xinmingm.vue?vue&type=style&index=0&id=474f2c44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports